import React from 'react'

interface GradientBannerProps {
  title: string
  description: string
  icon?: string
  variant?: 'info' | 'warning' | 'success'
}

/**
 * Explanatory banner with gradient background
 *
 * Provides contextual help and explanations for settings sections.
 * Light theme with subtle gradients.
 */
export const GradientBanner: React.FC<GradientBannerProps> = ({
  title,
  description,
  icon,
  variant = 'info'
}) => {
  // Gradient variants matching light theme
  const variantStyles = {
    info: 'bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-200 text-blue-900',
    warning: 'bg-gradient-to-r from-amber-50 to-orange-50 border-amber-200 text-amber-900',
    success: 'bg-gradient-to-r from-green-50 to-emerald-50 border-green-200 text-green-900'
  }

  return (
    <div className={`rounded-lg border p-4 ${variantStyles[variant]}`}>
      <div className="flex items-start gap-3">
        {icon && (
          <div className="text-2xl flex-shrink-0 mt-0.5">
            {icon}
          </div>
        )}
        <div className="flex-1">
          <h4 className="text-sm font-semibold mb-1">{title}</h4>
          <p className="text-sm opacity-90">{description}</p>
        </div>
      </div>
    </div>
  )
}
